import{FinalRequirementFilters,FinalRequirementDetails, RMH, JobType,Brand,Crop,Language,State, jobNumber,Year} from "../MCPlanningMaterial/mcplanningmaterial"
//#region Material-Allocation
export class MaterialAllocationFilter extends FinalRequirementFilters
{
rmhs :RMH[];
jobTypes:JobType[];
brands:Brand[];
crops:Crop[];
languages:Language[];
Month:any[];
states:State[];
jobNumbers:jobNumber[];
userID:userID[];
Year:Year[];
}
export class MaterialAllocationDetails
{
    // JobNumber:string;
	// RMHName:string;
	// State:string;
	// Brand:string;
	// JobType:string;
	// Crop:string;
	// Language:string;
	// EstimatedDelivery:Date;
    // FinalApprovedQTY:number;
	// Name:string;
	// UserID:string;
	// Designation:string;
	// AllocateQTY:string;
	// TotalRemaining:string;
    // Status:string;
    
    requirementDetailsID:any;
    jobNumber:string;
    rmhName:string;
    rmhid:string;
    jobType:string;
    brand:string;
    crop:string;
    language:string;
    state:string;
    month:string
    requestedQuantity:any;
    availableinInventory:any;
    finalQuantity:any;
    approvedQuantity:any;
    approvedQuantityCopy:any;
    deliveryDeadline:any;
    status:any;
    isSavedAsDraft:boolean;
    isSubmitted:boolean;
    allocatedQuantity:number;
    totalRemaining:number;
    isSelected:boolean=false;
    RequirementType:number;
    statusID:number;
    regionCode:string;
}
export class userID
{
    name:string;
    userID:string;
    roleName:string;
    regionCode:string;
}
export class CurrentRequirementYear{
    year: string;
    currentrequirementYear: string;
}
export class MaterialAllocation extends FinalRequirementDetails
{
    allocatedQuantity:number;
    allocateID:number;
    approvedQuantity:number;
    isSavedasDraft:boolean;
    isSubmitted:boolean;
    jobNumber:string;
    requirementID:number
    totalRemaining:number
    userID:string
    userName:string
    userRole:string
}

export class popMaterialAllocation 
{
    displayViewPanel: string = 'block';
    displayEditPanel: string = 'none';
    popJobNumber: string;
    popEstDel: string;
    popRMH: string;
    popLanguage: number;
    popState: string;
    popBrand: string;
    popJobType: string;
    popCrop: string;
    popFAQ: number;
    popName: string;
    popUserID: string;
    popDesg: string;
    popAQty: number;
    popStatus: number;
    popTotalremainingqty: number;
    popRequirmentID: number;
    hdnLimit: boolean = true;
    errorMessage: string;
    IsValidRole: boolean = false;
    selectCheck: number;
    TotalRemainingQuantity: number = 0;
}
export class uploadException
{
    jobNumber:string;
    statement:string;
}
export class Region
{
    regionCode:string;
    approvedQuantity:number;
    totalRemaining:number;
    isSavedasDraft:number;
}
//#endregion
